module.exports = "/_next/static/images/147c413eade98aba17915ecc3af54687-players@3x.png.webp";